module.exports = __webpack_public_path__ + "static/media/du.dbd90166.jpg";